import { FC } from "react";
import { Box, Card, makeStyles, useMediaQuery } from "@material-ui/core";
import moment from "moment";

import { AccountInfo, CardActionArea } from "components";
import { EMPTY_VALUE_PLACEHOLDER } from "constants/index";
import {
  formatAmountCompact,
  formatCurrencyAmount,
  formatCurrencyString,
} from "lib/format";
import { OtherSourceSubmission } from "services/otherSourceSubmissions/types";
import theme, { Theme } from "theme";
import { thinBorderStyles } from "theme/constants";

const useStyles = makeStyles<Theme, { isSmDown: boolean }>(() => ({
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: props => (props.isSmDown ? "unset" : "245px"),
    padding: "20px",
  },
  actionAreaContainer: thinBorderStyles,
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
}));

export interface OtherSourceSubmissionCardProps {
  otherSourceSubmission: OtherSourceSubmission;
}

const OtherSourceSubmissionCard: FC<OtherSourceSubmissionCardProps> = ({
  otherSourceSubmission,
}) => {
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles({ isSmDown });

  const isMd = useMediaQuery(theme.breakpoints.only("md"));

  const stats = [
    {
      label: "Yearly Earnings",
      value: isMd
        ? formatCurrencyString(
            "USD",
            formatAmountCompact(Number(otherSourceSubmission.attested_ltm)),
          )
        : formatCurrencyAmount("USD", otherSourceSubmission.attested_ltm),
    },
    {
      label: "Earning Since",
      value: moment()
        .subtract(otherSourceSubmission.attested_age, "years")
        .format("YYYY"),
    },
  ];

  return (
    <Card elevation={3} className={classes.card}>
      <Box className={classes.header}>
        <AccountInfo
          royaltyPayorDisplayName={otherSourceSubmission.royalty_payor_name}
          username={`My ${otherSourceSubmission.royalty_payor_name} Account`}
          subAccountName=""
        />
      </Box>
      <Box className={classes.actionAreaContainer}>
        <CardActionArea
          stats={stats}
          lastUpdated={
            otherSourceSubmission?.updated_at
              ? moment(otherSourceSubmission?.updated_at).format("MM/DD/YY")
              : EMPTY_VALUE_PLACEHOLDER
          }
        />
      </Box>
    </Card>
  );
};

export default OtherSourceSubmissionCard;
